import { render } from "./SubscribeModal.vue?vue&type=template&id=315d86b2"
import script from "./SubscribeModal.vue?vue&type=script&lang=js"
export * from "./SubscribeModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__